import _regenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.starts-with";
import _objectSpread from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import router, { asyncRoutes, constantRoutes } from "./router";
import store from "./store";
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { createBizCodeGuard } from "./router/guards"; // 业务代码路由守卫

var routes_loaded = false;
var bizCodeGuard = createBizCodeGuard(); // Correctly define bizCodeGuard

NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// 白名单路由，这些路由不需要业务上下文，也不需要登录（或有自己的登录处理）
var whiteList = ['/login', '/moa/login', '/moa/logout', '/404', '/select-business', '/redirect'];
router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(to, from, next) {
    var title, token, allRoutes, _require, getCurrentBizCode, bizCode, toPathRequiresBiz, realPath, routeRequiresBizCodeGuard, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          NProgress.start();
          console.log("[Router] Navigation: ".concat(from.path, " -> ").concat(to.path));
          if (to.meta && to.meta.title) {
            title = to.meta.title;
            if (process.env.VUE_APP_NAME) {
              title = process.env.VUE_APP_NAME + ' - ' + title;
            }
            document.title = title;
          }

          // 处理特殊的MOA登录/登出路径
          if (!(to.path === '/moa/logout')) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return store.dispatch('user/logout');
        case 1:
          // 确保logout是异步完成的
          next({
            path: '/login'
          }); // 登出后通常到登录页
          NProgress.done();
          return _context.a(2);
        case 2:
          if (!(to.path === '/moa/login')) {
            _context.n = 7;
            break;
          }
          if (to.query.token) {
            _context.n = 4;
            break;
          }
          _context.n = 3;
          return store.dispatch('user/login');
        case 3:
          _context.n = 6;
          break;
        case 4:
          _context.n = 5;
          return store.dispatch('user/update', to.query);
        case 5:
          next(to.query.route || '/'); // 登录后跳转
          NProgress.done();
        case 6:
          return _context.a(2);
        case 7:
          token = store.state.user.token; // 如果应用启用了认证且用户没有token
          if (!(!store.state.app.auth_disabled && !token)) {
            _context.n = 8;
            break;
          }
          if (whiteList.includes(to.path)) {
            // 如果在白名单中（如 /login, /select-business），则直接进入
            next();
          } else {
            // 否则重定向到登录页，并带上原始请求路径以便登录后跳转回来
            console.log("[Router] No token, redirecting to login. Target: ".concat(to.fullPath));
            next({
              path: '/login',
              query: {
                redirect: to.fullPath
              },
              replace: true
            });
            NProgress.done();
          }
          return _context.a(2);
        case 8:
          if (routes_loaded) {
            _context.n = 13;
            break;
          }
          console.log('[Router] Initializing routes and loading business data');
          _context.p = 9;
          _context.n = 10;
          return store.dispatch('profile/refreshBiz');
        case 10:
          // 获取业务列表
          console.log("[Router] Business data loaded, current bizCode from store after refreshBiz: ".concat(store.state.profile.currBizCode));
          allRoutes = [].concat(_toConsumableArray(constantRoutes), _toConsumableArray(asyncRoutes));
          router.addRoutes(allRoutes);

          // 更新路由状态，确保导航栏能正确渲染
          store.commit('route/SET_ROUTES', allRoutes);
          // 同时更新权限路由状态
          store.commit('permission/SET_ROUTES', asyncRoutes);
          routes_loaded = true;
          next(_objectSpread(_objectSpread({}, to), {}, {
            replace: true
          }));
          _context.n = 12;
          break;
        case 11:
          _context.p = 11;
          _t = _context.v;
          console.error('[Router] Error during initial route load or refreshBiz:', _t);
          store.dispatch('user/logout'); // 清理状态
          next({
            path: '/login',
            query: {
              redirect: to.fullPath
            }
          }); // 或 '/select-business' 如果认为用户已登录但业务加载失败
        case 12:
          return _context.a(2);
        case 13:
          _require = require('@/utils/routeHelper'), getCurrentBizCode = _require.getCurrentBizCode;
          bizCode = getCurrentBizCode();
          console.log("[Router] bizCode from getCurrentBizCode(): ".concat(bizCode));
          if (!bizCode && store.state.profile.bizList && store.state.profile.bizList.length > 0) {
            if (store.state.profile.currBizCode && store.state.profile.bizList.some(function (b) {
              return b.code === store.state.profile.currBizCode;
            })) {
              bizCode = store.state.profile.currBizCode;
              console.log("[Router] Used bizCode from store.state.profile.currBizCode: ".concat(bizCode));
            }
          }
          toPathRequiresBiz = to.path.startsWith('/biz/') || to.matched.some(function (record) {
            return record.meta.requiresBiz;
          }) && !whiteList.includes(to.path);
          console.log("[Router] Path: ".concat(to.path, ", requiresBizContext: ").concat(toPathRequiresBiz, ", currentBizCode: ").concat(bizCode));
          if (!toPathRequiresBiz) {
            _context.n = 16;
            break;
          }
          if (bizCode) {
            _context.n = 14;
            break;
          }
          console.log("[Router] Path ".concat(to.path, " requires bizCode, but none found. Redirecting to /select-business."));
          next({
            path: '/select-business',
            query: {
              redirect: to.fullPath
            },
            replace: true
          });
          NProgress.done();
          return _context.a(2);
        case 14:
          if (!to.path.includes('/biz/:biz_code')) {
            _context.n = 15;
            break;
          }
          realPath = to.path.replace('/biz/:biz_code', "/biz/".concat(bizCode));
          console.log("[Router] Path ".concat(to.path, " contains placeholder, redirecting to ").concat(realPath));
          next({
            path: realPath,
            replace: true
          });
          NProgress.done();
          return _context.a(2);
        case 15:
          if (to.params.biz_code && to.params.biz_code !== bizCode) {
            console.warn("[Router] URL biz_code ".concat(to.params.biz_code, " differs from context bizCode ").concat(bizCode, ". Letting bizCodeGuard handle."));
          }
          _context.n = 17;
          break;
        case 16:
          if (!(bizCode && !whiteList.includes(to.path) && to.path !== '/')) {
            _context.n = 17;
            break;
          }
          console.log("[Router] Has bizCode (".concat(bizCode, "), but target ").concat(to.path, " is not a biz path or whitelist. Redirecting to /biz/").concat(bizCode, "/index."));
          next({
            path: "/biz/".concat(bizCode, "/index"),
            replace: true
          });
          NProgress.done();
          return _context.a(2);
        case 17:
          routeRequiresBizCodeGuard = to.matched.some(function (record) {
            return record.beforeEnter === bizCodeGuard;
          });
          if (routeRequiresBizCodeGuard) {
            bizCodeGuard(to, from, next);
          } else {
            next();
          }
        case 18:
          return _context.a(2);
      }
    }, _callee, null, [[9, 11]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});